__turbopack_context__.v({
  "fontMedium": "sZe0Ha_fontMedium",
  "overflowContainer": "sZe0Ha_overflowContainer",
  "table": "sZe0Ha_table",
  "tableCell": "sZe0Ha_tableCell",
  "tableCellHeader": "sZe0Ha_tableCellHeader",
  "tableContainer": "sZe0Ha_tableContainer",
  "tableHead": "sZe0Ha_tableHead",
  "tableRow": "sZe0Ha_tableRow",
  "wrapper": "sZe0Ha_wrapper",
});
